import { render, staticRenderFns } from "./LaboratoryService.vue?vue&type=template&id=fdac0f0a&scoped=true"
import script from "./LaboratoryService.vue?vue&type=script&lang=js"
export * from "./LaboratoryService.vue?vue&type=script&lang=js"
import style0 from "./LaboratoryService.vue?vue&type=style&index=0&id=fdac0f0a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fdac0f0a",
  null
  
)

export default component.exports